var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1833,
    height: 1833,
    viewBox: "0 0 1833 1833",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1824.6 795C1824.5 794.3 1824.4 793.5 1824.3 792.8L1819 795H1824.6Z",
    fill: "#EE8933"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M916.6 1460.7C616.4 1460.7 372.1 1216.4 372.1 916.2C372.1 616 616.4 371.7 916.6 371.7C1118.1 371.7 1294.2 481.8 1388.3 644.8L1732.8 500C1581.2 203.3 1272.6 0.200012 916.6 0.200012C410.7 0.200012 0.599976 410.3 0.599976 916.2C0.599976 1422.1 410.7 1832.2 916.6 1832.2C1272.6 1832.2 1581.2 1629.1 1732.8 1332.4L1388.4 1187.6C1294.2 1350.6 1118.1 1460.7 916.6 1460.7Z",
    fill: "#EE8933"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M916.6 1155.4C1048.71 1155.4 1155.8 1048.31 1155.8 916.2C1155.8 784.093 1048.71 677 916.6 677C784.493 677 677.4 784.093 677.4 916.2C677.4 1048.31 784.493 1155.4 916.6 1155.4Z",
    fill: "#EE8933"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1824.6 795H1819L1671.8 856.9L1530.7 916.2L1824.3 1039.6C1829.4 1001.9 1832.2 963.4 1832.5 924.4C1832.5 921.7 1832.6 918.9 1832.6 916.2C1832.6 875.1 1829.8 834.7 1824.6 795Z",
    fill: "#EE8933"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.adc05725c40ad9927dd0f0b3d4857851.svg";
export { ForwardRef as ReactComponent };